/**
 * @file   公共面包屑
 * @create macaiqi 2021/07/27
 * @update
 */
import React from 'react';
// import { Link } from 'react-router-dom';
import './index.scss';

const Bread = (props) => {
  // const { path, title } = props;
  return (
    <div className="bread">
      {/* <Link to="/" className="tohome itemlink">
        <i className="iconfont icon-shouyetianchong" />
        <span>首页</span>
      </Link>
      {path ? (
        <Link to={path} className="itemlink">
          <span>{title}</span>
        </Link>
      ) : (
        <div className="itemlink">
          <span>{title}</span>
        </div>
      )} */}
    </div>
  );
};

export default Bread;
